import { Product } from "@/types";
import { getData, postData, putData, deleteData } from "./axios-service"
import { ReservationStatus } from "@/types";


function modelMapper(inputProduct: any): Product {
    return {
        id: inputProduct.id,
        // In the treeView we need to have name attribute to return it as label
        name: inputProduct.aquaNb,
        price: inputProduct.price,
        model: inputProduct.model,
        aquaNb: inputProduct.aquaNb,
        serialNb: inputProduct.serialNb,
        compteur: inputProduct.compteur,
        laverieId: inputProduct.laverieId,
        storageDepotId: inputProduct.storageDepotId,
        bonEntreeNb: inputProduct.bonEntreeNb,
        destructionDate: inputProduct.destructionDate,
        productMake: inputProduct.productMake,
        productType: inputProduct.productType,
        bonEntreeDate: inputProduct.bonEntreeDate,
        localisation: inputProduct.localisation,
        notificationEnabled: inputProduct.notificationEnabled,
        productStatus: inputProduct.productStatus,
        reservationStatus: inputProduct.reservationStatus
    };
}

export function modelMapperArray(inputArray: any[]): Product[] {
    return inputArray.map(modelMapper);
}

export async function getAllProducts(): Promise<Product[]> {
    const products = await getData<Product[]>("products");
    return modelMapperArray(products ?? []);
}

export async function getFilteredProducts(reservationStatuses: ReservationStatus[]): Promise<Product[]> {
    const products = await getData<Product[]>("products?reservation_status=" + reservationStatuses.join(","));
    return modelMapperArray(products ?? []);
}

export function getProductById(id: string): Promise<Product> {
    return getData("/products/" + id).then(
        onSucceed => {
            return modelMapper(onSucceed);
        }
    );
}

export async function getProductsByLaverieId(laverieId: string): Promise<Product[]> {
    const url = `/products?laverieId=${laverieId}`;
    const products = await getData<Product[]>(url);
    return modelMapperArray(products);
}

export function postProduct(product: Product): Promise<Product> {
    return postData("products", product).then(
        onSucceed => {
            return modelMapper(onSucceed);
        }
    );
}

export function putProduct(id: string, product: Product): Promise<any> {
    return putData("products/" + id, product)
}

export function deleteProduct(ids: string[]): Promise<any> {
    const idsStr = ids.join(',');
    return deleteData("products/" + idsStr)
}

export async function searchForProducts(searchQuery: string): Promise<Product[]> {
    const products = await getData<Product[]>("products?" + searchQuery);
    return modelMapperArray(products ?? []);
}